<template>
    <div class="pt-3 pl-5 pr-5 overflow-y-hidden">
        <div class="row w-full justify-between flex" style="align-items: center">
            <h1 class="title">Roles</h1>
            <div class="cardbody">
                <div class="flex flex-row-reverse items-center gap-3">
                    <div class="flex flex-row-reverse items-center">
                        <button class="flex items-center"  @click="filterOpen" :class="usersArray.length == 0?'btndisabled pointer-events-none':'filterButton'">
                            <img  v-if="usersArray.length == 0" src="@/assets/filterIconDisabled.svg" class="filterIcon"/>
                            <img v-else src="@/assets/filterIcon.svg" class="filterIcon" />
                            Filters
                        </button>
                    </div>
                    <div class="text-center">
                      <button class="btnprimary" @click="showPopUp()">Add</button>
                   </div>
                </div>
            </div>
        </div>
        <div class="my-3 text-xs">
            Add new users, assign roles, update permissions, and remove access when needed. It’s the central place to manage who can do what in your app, making team collaboration secure and efficient.
        </div>
        <div>
            <newTable :tableRowData="usersArray" :headersData="headers" :tableProps="tableProps" :openPopup="false" :navigate="true" :loadData="dataLoading"></newTable>

            <div v-if="toolTipActive">
                <tool-tip :tipText="toolTipText"></tool-tip>
            </div>
        </div>
        <popup v-if="showAddPopup" :popUp="showAddPopup">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popup-header popupheadingcontainer rounded"
        >
          <h1>Roles</h1>
          <button
            class="float-right text-3xl"
            @click="onCancelButtonAddPopUp()"
          >
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
  <div class="flex flex-col h-full popup-body">
    <div class="flex-1 overflow-auto">
      <div class="formcontainer px-4 pb-4 flex flex-col">
        <div class="row flex flex-row upperspacing">
          <div class="w-6/12">
            <label class="controllabel">User mail id</label>
            <input
            class="inputboxstyling mt-2" 
            placeholder="user@example.com"  
            v-model.trim="userObj.userMailId"  
            :disabled="editPopup==true||!userObj.isActive"
            @input="handleEmailInput()" 
            :class="{'is-invalid': v$.userObj.userMailId.$error|| emailExists}"/>
            <div v-if="v$.userObj.userMailId.$error" class="text-red-500">
              <div class="error-text text-xs" v-if="v$.userObj.userMailId.required.$invalid">Required</div>
              <div v-else-if="v$.userObj.userMailId.required&& v$.userObj.userMailId.emailValidation" class="invalid-feedback text-xs">Email is Invalid</div>
            </div>
            <div v-if="emailExists" class="text-red-500">
      <div class="error-text text-xs">This email already exists</div>
    </div>
          </div>
          <div class="w-6/12 pl-4">
            <label class="controllabel">Username</label>
            <input
              class="inputboxstyling mt-2" 
            placeholder="Username"  
            :disabled="!userObj.isActive"
            v-model.trim="userObj.userName"  
            @input="v$.userObj.userName.$touch()" 
            :class="{'is-invalid': v$.userObj.userName.$error}"/>
            <div v-if="v$.userObj.userName.restrictCharacters20.$invalid" class="text-red-500">
              <div class="error-text text-xs">Charcter Limit is exceeded</div>
            </div>
          </div>
        </div>
          <div class="flex h-full justify-between pt-4">
                <div class="w-1/2">
                    <label class="controllabel mr-2 mb-2">Status</label>
                    <label class="switch">
                        <input type="checkbox" v-model="userObj.isActive" :disabled="userObj.userMailId == 'ranjith@crystallinesoft.com' && userObj.superUser==true"/>
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="w-1/2 flex items-center activeStyle" v-if="userObj.isActive">
                    <input
                        type="checkbox"
                        id="superUser"
                        class="checkbox"
                        v-model="userObj.superUser"
                        :disabled="userObj.userMailId == 'ranjith@crystallinesoft.com' && userObj.superUser==true"
                    />
                    <label class="font-extrabold text-xs cursor-pointer pl-2" for="superUser">Super User</label>
                </div>
            </div>
        <div v-if="userObj.superUser==false">
        <div class="flex items-center mt-4" v-if="userObj.isActive">
            <div class="w-full">
                <h1>Roles</h1>
            </div>
            <div>
                <button :class="!userObj.isActive ? 'btndisabled' : 'btnprimary'" @click="addRoleActions()">Add</button>
            </div>
        </div>
        <div class="border-b mt-1 border-solid border-lightgrey mt-2" v-if="userObj.isActive"/>
            <div v-if="usersRoleTenent?.length == 0 && userObj.isActive" class="text-red-500">
                <div class="error-text text-sm">At least one Tenent and Role is needed</div>
            </div>
            <div v-else>
            <div v-if="userObj.isActive">
            <div class="flex mt-4" v-for="(obj,index) in usersRoleTenent" :key="obj" >
                <div class="w-6/12 mr-4">
                    <label class="controllabel">Tenant</label>
                        <div>
                            <select
                                v-model="obj.tenant"
                                :class="{
                                    'inputboxstylingForSelectAtPopup': obj.tenant === '',
                                    'stylingForInputboxstylingForSelectAtPopup': obj.tenant !== '',
                                    'is-invalid borderRed': v$.usersRoleTenent.$dirty &&!v$.usersRoleTenent.$each.$response.$data[index].tenant.required,
                                }"
                            >
                                <option value="" selected hidden>Please select a Tenant</option>
                                <option class="optionColors" v-for="option in filterTenantOptions(index)" :key="option.value" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </select>

                            <div v-if="v$.usersRoleTenent.$dirty && !v$.usersRoleTenent.$each.$response.$data[index].tenant.required" class="text-red-500">
                                <div class="error-text text-xs">Required</div>
                            </div>
                            
                        </div>
                    <!-- </div> -->
                </div>
                <div class="w-6/12 mr-5">
                    <label class="controllabel">Role</label>
                    <div v-if="obj.length == 0" class="text-red-500">
                        <div class="error-text">At least one Role is needed</div>
                    </div>
                    <div v-else>
                        <select
                            v-model="obj.role"
                            :disabled="obj.tenant==''||!userObj.isActive"
                            :class="{
                                'inputboxstylingForSelectAtPopup': obj.role === '',
                                'stylingForInputboxstylingForSelectAtPopup': obj.role !== '',
                                'is-invalid borderRed': v$.usersRoleTenent.$dirty &&!v$.usersRoleTenent.$each.$response.$data[index].role.required,
                            }"
                        >
                            <option value="" selected hidden>Please select a role</option>
                            <option class="optionColors" v-for="option in roleOptions" :key="option.id" :value="option.id">
                                {{ option.value }}
                            </option>
                        </select>

                        <div v-if="v$.usersRoleTenent.$dirty && !v$.usersRoleTenent.$each.$response.$data[index].role.required" class="text-red-500">
                            <div class="error-text text-xs">Required</div>
                        </div>
                        
                    </div>
                    <div>
                </div>
                    
                    

                </div>
            <div class="flex items-center pt-5">
                <div>
                <img
                    src="@/assets/deleteIcon.svg"
                    class="cursor-pointer"
                    @click="clickedOnDeleteButton(index)"
                />
                </div>

            </div>     
        </div>
            </div>
            </div>
        </div>
      </div>
    </div>
    <div class="popup-footer">
        <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div v-if="editPopup==false" class="flex items-center justify-end pb-4 pl-5 pt-4 pr-5">
          <button
          :class="(JSON.stringify(dummyUserObj) == JSON.stringify(userObj) && JSON.stringify(dummyRoleTenentObj) == JSON.stringify(usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary'"
            class="btnprimary mr-2"
            :disabled="clickOnButton" @click="onCancelbtn()"
          >
            Reset
          </button>
          <button
            :class="(JSON.stringify(dummyUserObj) == JSON.stringify(userObj) && JSON.stringify(dummyRoleTenentObj) == JSON.stringify(usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary'"
            :disabled="clickOnButton" @click="onSavebtn()"
          >
            Save
          </button>
        </div>
        <div v-if="editPopup==true" class="flex items-center justify-end pb-4 pl-5 pt-4 pr-5">
          <button
          :class="(JSON.stringify(dummyUserObj) == JSON.stringify(userObj) && JSON.stringify(dummyRoleTenentObj) == JSON.stringify(usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary'"
            :disabled="clickOnButton" class="btnprimary mr-2"
            @click="onCancelbtn()"
          >
            Reset
          </button>
          <button
            :class="(JSON.stringify(dummyUserObj) == JSON.stringify(userObj) && JSON.stringify(dummyRoleTenentObj) == JSON.stringify(usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary'"
             :disabled="clickOnButton" @click="onUpdatebtn()"
          >
            Save
          </button>
        </div>
    </div>
    </div>
    </popup>
        
        
    </div>
</template>

<style>
.popup {
  height: 90vh;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.popup-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.popup-header {
  flex-shrink: 0;
}

.popup-body {
  flex: 1;
  min-height: 0;       
  overflow-y: auto;
}

.popup-footer {
  flex-shrink: 0;
}
.activeStyle{
    padding-left: 16px;
    padding-top: 25px;
}
    .deleteHeight{
        height: 145%;
    }
    ::-webkit-scrollbar {
        width: 3px !important;
    }
    .disabled{
        opacity: 1;
    }
    .optionColors{
        color: black;
    }
    .slider.round::before{
        border-radius: 50%;
        padding-left: 0px;
        margin-left: 0px;
        width: 17px;
        height: 17px;
    }
    input:checked+.slider{
        background-color:#00b044 !important
    }
    .slider{
        background-color:#c00000 !important
    }
    
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import newTable from '@/components/newTable.vue';
import popup from '@/components/sidePopup.vue';
import toolTip from '@/components/toolTip.vue';
import { emitter, toast } from '@/main';
import { required,email } from '@vuelidate/validators';
import { helpers } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { mapGetters } from "vuex";
const restrictCharacters20 = helpers.regex(/^.{0,20}$/);
const restrictCharacters60 = helpers.regex(/^.{0,60}$/);
const emailValidation = (value:any) => {
  if (!value) return true;
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in)$/.test(value);
};


export default defineComponent({
    data() :any{
        return {
            v$:useVuelidate(),
            show:false,
            clickOnButton:false,
            showAddPopup:false,
            headers:['userMailId','userName','isActive'],
            dataLoading:true,
            toolTipText:'',
            toolTipActive:false,
            tenantOptions:[],
            userObj: {
                userMailId:'',
                userName:'',
                superUser:false,
                isActive: true,
            },
            tenants:[],
            tenentsFiltered: [],
            addDisiable:false,
            dummyList:[],
            dummyUserObj:{},
            editPopup: false,
            allUsers:[],
            usersArray:[],
            showFilters:false,
            emailExists: false,
            usersRoleTenent: [{ tenant: "" ,role:""}],
            dummyRoleTenentObj: {},
            tableProps:{
                headerNames:[{key:'userMailId',value:'Mail id'},{key:'userName',value:'User Name'},{key:'isActive',value:'Status'}],
                
                headerWidth:[{key:'userMailId',value:'w-2/5'},{key:'userName',value:'w-2/5'},{key:'isActive',value:'w-5/5 flex justify-center items-center'}],
            },
            roleOptions:[
                {
                    id:10215,
                    value:'Compliance Officer'
                },
                {
                    id:10216,
                    value:'Compliance Analyst'
                },
                {
                    id:10217,
                    value:'Auditor'
                }
            ],
        }
    },
    components:{
        toolTip,
        popup,
        newTable,
    },
    validations() {
        return {
            userObj:{
                userMailId:{ required,emailValidation,restrictCharacters60},
                userName:{ restrictCharacters20},
            },
            usersRoleTenent: {
                $each: helpers.forEach({
                role: { required },
                tenant:{required}
            }),
      },
        }
    },
    computed:{
        ...mapGetters({
            userInfo: 'userInfo',
        }),
    },
    methods:{
       filterOpen() {
            this.showFilters = !this.showFilters;
            if (this.showFilters == true) {
                this.dummyList = this.usersArray;
            } else {
                this.usersArray = this.dummyList;
            }
            emitter.emit('visible',this.showFilters)
        },
        onCancelbtn(){
            this.v$.$reset();
            if(this.editPopup == false){
                this.userObj.userMailId = ''
                this.userObj.userName = ''
                this.usersRoleTenent = [{ tenant: "",role:"" }];
                this.userObj.superUser=false
                this.userObj.isActive=true
            } else {
                this.userObj = {...this.dummyUserObj}
                this.usersRoleTenent = this.dummyRoleTenentObj.map((obj:any) => ({ ...obj }));
                // this.usersRoleTenent = [...this.dummyRoleTenentObj];
            }
        },
        filterTenantOptions(index:any) {
            const selected = (Array.isArray(this.usersRoleTenent) ? this.usersRoleTenent : [])
                .map((u:any) => u.tenant)
                .filter(Boolean);
            return this.tenantOptions.filter(
                (t:any) => !selected.includes(t.value) || this.usersRoleTenent[index].tenant === t.value
            );
        },

        clickedOnDeleteButton(index: number) {
            this.usersRoleTenent.splice(index, 1);
        },
       getAllTenants() {
           this.$http.get(`${process.env.VUE_APP_AUTH_API}/tenants/getAll`).then((res: any) => {
				this.tenants=res.data
                this.tenants.forEach((tenant:any) => {
                    // {{tenant.organisationType}}
				if(tenant.organisationType!=10701){
                    this.tenantOptions.push({
                        value: tenant._id,   
                        label: tenant.displayName, 
                });


                }
			});
		})
       },
    getAllUsers() {
        this.$http.get(`${process.env.VUE_APP_ADMIN_API}/api/admin/users/getAll`).then((res: any) => {
            res.data.map((user: any)=>{
                    this.allUsers.push(user)
            })
		});
            
	},
    async getAllUserPermssions() {
        this.usersArray = [];
        const res = await this.$http.get(`${process.env.VUE_APP_AUTH_API}/admin/users/Permissions/getAll`);
        res.data.forEach((user: any) => {
            let tenantsRoles = [];
            if (user.isSuperUser==false && user.isActive==true) {
                tenantsRoles = user.tenants?.map((tenant: any) => ({
                    tenantid: tenant.tenant_id,
                    roleid: tenant.role_id,
                }));
            }
            const userArrayData = {
                _id: user._id,
                userMailId: user.email,
                userName: user.name && user.name.trim() !== "" ? user.name : "N/A",
                tenantsRoles: tenantsRoles,
                userId: user.userId,
                isSuperUser: user.isSuperUser,
                isActive:user.isActive==true ? 1 : 2,
            };
            this.usersArray.push(userArrayData);
        });
    },
        handleEmailInput() {
            this.v$.userObj.userMailId.$touch();
            const userEmail = this.userObj.userMailId?.trim().toLowerCase();
            this.emailExists = this.usersArray.some(
                
                (user:any) => user.userMailId?.toLowerCase() == userEmail
            );
        },
       
        addRoleActions() {
            this.v$.$reset();
            const selected = (Array.isArray(this.usersRoleTenent) ? this.usersRoleTenent : []).map((u:any) => u.tenant).filter(Boolean);
            this.tenentsFiltered = this.tenantOptions.filter(
                (t:any) => !selected.includes(t.value)
            );
            if (this.tenentsFiltered.length> 0) {
                this.usersRoleTenent.push({ tenant: "", role: "" });
            }
        },
        isValid() {
            const emailValid =
                !this.v$.userObj.userMailId.required.$invalid &&
                !this.v$.userObj.userMailId.emailValidation.$invalid &&
                !this.emailExists;
            const rolesValid =
                this.usersRoleTenent?.length > 0 &&
                this.usersRoleTenent.every((obj: any) => obj.tenant && obj.role);
            if (this.userObj.superUser || !this.userObj.isActive) {
                return emailValid;
            }
            return emailValid && rolesValid;
        },
    async onSavebtn() {
    this.v$.$touch();
    let payload: any = {
        tenants: []
    };
    if (this.userObj.superUser || !this.userObj.isActive) {
        if (this.v$.userObj.$invalid) return;

        this.clickOnButton = true;
        payload.name = this.userObj.userName;
        payload.email = this.userObj.userMailId;
        payload.isSuperUser = this.userObj.superUser;
        payload.isActive = this.userObj.isActive;
        payload.tenants = [];
        const existing = this.allUsers.find(
            (u: any) => u.email === this.userObj.userMailId
        );
        if (existing) {
            payload.userId = existing._id;
        }
        payload.createdAt = new Date();
        payload.createdBy = this.userInfo._id;
    }

    else {
        if (!this.v$.userObj.$invalid && !this.v$.usersRoleTenent.$invalid && this.usersRoleTenent.length != 0) {
            this.clickOnButton = true;
            payload.createdAt = new Date();
            payload.createdBy = this.userInfo._id;
            payload.name = this.userObj.userName;
            payload.isActive=this.userObj.isActive;
            payload.isSuperUser = this.userObj.superUser;
            payload.email = this.userObj.userMailId;
             const existing = this.allUsers.find((u: any) => {
            return u.email === this.userObj.userMailId});
            if (existing) {
                payload.userId = existing._id;
            }

        this.usersRoleTenent?.forEach((tenantObj: any) => {
            const tenantInfo = this.tenants.find((t: any) => t._id === tenantObj.tenant);
            const tenantName = tenantInfo ? tenantInfo.tenantName : '';
            const roleInfo = this.roleOptions.find((r: any) => r.id === tenantObj.role);
            const roleName = roleInfo ? roleInfo.value : '';
            const permissions = [10301, 10302,10303,10304,10305,10306];
            let org:any= {
                appId:10008,
                appName:'Org',
                isActive:true
            }            
            const exists = tenantInfo.apps.some((app: any) => app.appId === org.appId);
            if (!exists) {
                tenantInfo.apps.push(org);
            }
            const apps = (tenantInfo?.apps || []).map((app: any) => ({
                appId: app.appId,
                app_name: app.appName,
                isActive: app.isActive,
                roles: [
                {
                    roleId: tenantObj.role,
                    role_name: roleName,
                    permissions: permissions
                }
            ]
        }));
        payload.tenants.push({
            tenant_id: tenantObj.tenant,
            role_name:roleName,
            role_id: tenantObj.role,
            apps: apps
        });
        });
    }
    }
    if (this.isValid()) {
        try {
            await this.$http.post(`${process.env.VUE_APP_AUTH_API}/admin/users/add`,payload).then((res: any) => {
                toast.info('Saved', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
            })
            this.showAddPopup = false
            await this.getAllUserPermssions();
        } catch (err) {
            toast.error('Error', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
        } finally {
            this.clickOnButton = false;
            this.showAddPopup = false;
            this.v$.$reset();
            this.userObj = { userMailId: "", userName: "",isActive: true, superUser: false};
            this.usersRoleTenent = [{ tenant: "", role: "" }];
        }
    } 
    },
   async onUpdatebtn() {
    this.v$.$touch();
    this.editpopup = true;

    if (!this.v$.userObj.$invalid && this.isValid()) {
        this.clickOnButton = true;
        try {
            const payload: any = {
                userId: this.userObj.userId,
                name:this.userObj.userName,
                isSuperUser:this.userObj.isActive==true?this.userObj.superUser:false,
                isActive:this.userObj.isActive,
                updatedAt: new Date(),
                updatedBy: this.userInfo._id,
                tenants: []
            };
            if (!this.userObj.superUser) {
                this.usersRoleTenent?.forEach((tenantObj: any) => {
                    const tenantInfo = this.tenants.find((t: any) => t._id === tenantObj.tenant);
                    const tenantName = tenantInfo ? tenantInfo.tenantName : '';

                    const roleInfo = this.roleOptions.find((r: any) => r.id === tenantObj.role);
                    const roleName = roleInfo ? roleInfo.value : '';
                    const permissions = [10301, 10302,10303,10304,10305,10306];
                    let org:any= {
                        appId:10008,
                        appName:'Org',
                        isActive:true
                    }            
                    const exists = tenantInfo.apps.some((app: any) => app.appId === org.appId);
                    if (!exists) {
                        tenantInfo.apps.push(org);
                    }
                    const apps = (tenantInfo?.apps || []).map((app: any) => ({
                        appId: app.appId,
                        app_name: app.appName,
                        isActive: app.isActive,
                        roles: [
                            {
                                roleId: tenantObj.role,
                                role_name: roleName,
                                permissions: permissions
                            }
                        ]
                    }));
                    payload.tenants.push({
                        tenant_id: tenantObj.tenant,
                        role_id: tenantObj.role,
                        role_name:roleName,
                        apps: apps
                    });
                });
            }

            const userId = this.userObj.id
            await this.$http.post(`${process.env.VUE_APP_AUTH_API}/admin/user/${userId}/update`,payload).then((res: any) => {
                    toast.info("Updated successfully", {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: "button",
                        icon: true
                    });
                });
        this.showAddPopup = false
        await this.getAllUserPermssions();

        } catch (err) {
            toast.error("Error while updating", {
                timeout: 1000,
                closeOnClick: true,
                closeButton: "button",
                icon: true
            });
        } finally {
            this.clickOnButton = false;
            this.showAddPopup = false;
            this.v$.$reset();
            this.userObj = { userMailId: "", userName: "" ,isActive: true, superUser: false};
            this.usersRoleTenent = [{ tenant: "", role: "" }];
        }
    }
},


        onCancelButtonAddPopUp(){
            this.v$.$reset();        
            this.showAddPopup = false
            this.userObj.superUser=false
            this.userObj.isActive=true
            this.userObj.userMailId = ''
            this.userObj.userName = ''
            this.usersRoleTenent=[{tenant:'',role:''}]
        },
        showPopUp(){
            this.editPopup = false
            this.showAddPopup = true
            this.dummyUserObj = {...this.userObj}
            this.dummyRoleTenentObj=[...this.usersRoleTenent]
        },
        showEditPopup(data: any) {
            if(!data.isSuperUser&&!data.isActive){
                 this.userObj = {
                    id:data._id,
                    userMailId: data.userMailId,
                    userName: data.userName=='N/A'||data.userName==undefined?'':data.userName,
                    userId:data.userId,
                    superUser: false,
                    isActive:false
                };
            }
            else{
                this.userObj = {
                    id:data._id,
                    userMailId: data.userMailId,
                    userName: data.userName=='N/A'||data.userName==undefined?'':data.userName,
                    userId:data.userId,
                    superUser: data.isSuperUser,
                    isActive:data.isActive==1?true:false
                };
            }
            if(data.isSuperUser==true&&data.isActive==true){
                this.usersRoleTenent=[{ tenant: "" ,role:""}]
                this.dummyRoleTenentObj = {...this.usersRoleTenent}
            }
            else{
                if(data.isSuperUser==false && data.isActive==2){
                    this.usersRoleTenent=[{ tenant: "" ,role:""}]
                }
                else{
                    this.usersRoleTenent = data.tenantsRoles?.map((tenent:any) => ({
                        tenant: tenent.tenantid,
                        role: tenent.roleid
                    }));
                }
            }
            this.dummyUserObj={...this.userObj}
            this.dummyRoleTenentObj = this.usersRoleTenent?.map((obj:any) => ({ ...obj }));
            this.editPopup = true;
            this.showAddPopup = true;
            }
    },
    async mounted(){
        this.dataLoading = true;
        await this.getAllUsers();
        await this.getAllUserPermssions();
        await this.getAllTenants();
        // await this.getAllTeams();
        this.dataLoading = false;
        emitter.off('dataTransfering');
        emitter.on('dataTransfering', (isData: any) => {
            // this.alleditteamNames=[]
            // this.alleditTeamDisplayNames=[]
            this.showEditPopup(isData)
            
        })
        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
    },
    async created() {
        
        // this.dataLoading = true;
        
      }  
    //     emitter.off('activiteToolTip');
    //     emitter.on('activiteToolTip', (data: any) => {
    //         this.toolTipActive = true;
    //         this.toolTipText = data.tipText
    //     });
 
    //     emitter.off('deActiviteToolTip');
    //     emitter.on('deActiviteToolTip', (data: any) => {
    //         this.toolTipActive = false;
    //         this.toolTipText = ''
    //     });
    // }
})
</script>
